import type { PanelState } from '../model/usePanelState';
import { WelcomeState } from './states/WelcomeState';
import { AddDocumentState } from './states/AddDocumentState';
import { AddSiteState } from './states/AddSiteState';
import { SourceDetailState } from './states/SourceDetailState';

interface Props {
  assistantId: string;
  state: PanelState;
  onGoWelcome: () => void;
  onAddDocument: () => void;
  onAddSite: () => void;
  /** Переключиться на детали конкретного источника (например после confirm). */
  onSelectSource: (sourceId: string) => void;
}

/**
 * Правая панель «База знаний» — переключает между 4 состояниями
 * по полю state.mode.
 *
 * Это тонкий router: вся логика состояний — в дочерних компонентах
 * states/*. Хук usePanelState (на уровне родителя KnowledgeBaseTab)
 * управляет переходами.
 */
export function SourceDetailPanel({
  assistantId,
  state,
  onGoWelcome,
  onAddDocument,
  onAddSite,
  onSelectSource,
}: Props) {
  switch (state.mode) {
    case 'welcome':
      return <WelcomeState onAddDocument={onAddDocument} onAddSite={onAddSite} />;

    case 'add-document':
      return <AddDocumentState assistantId={assistantId} onBack={onGoWelcome} />;

    case 'add-site':
      return (
        <AddSiteState
          assistantId={assistantId}
          onBack={onGoWelcome}
          onSourceConfirmed={onSelectSource}
        />
      );

    case 'detail':
      return (
        <SourceDetailState
          assistantId={assistantId}
          sourceId={state.sourceId}
          onSourceGone={onGoWelcome}
        />
      );

    default: {
      // Exhaustive check на случай добавления новых mode без обновления switch
      const _exhaustive: never = state;
      return null;
    }
  }
}
